import { FolderIcon, SharedFolderIcon } from '@carboncopyco/icons';
import type { WorkspaceFolder } from '@carboncopyco/types';
import {
  ColorHex,
  NavigationCard,
  TextButton,
  TooltipBubble,
} from '@carboncopyco/ui';
import { useState } from 'react';
import { FolderActions } from './FolderActions';

export interface FolderGridTileProps {
  disabled?: boolean;
  onTileClick: (folder: WorkspaceFolder) => void;
  folder: WorkspaceFolder;
  isArchived?: boolean;
  dataDsId?: string;
}
export const FolderGridTile = ({
  disabled,
  onTileClick,
  folder,
  isArchived,
  dataDsId,
}: FolderGridTileProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <NavigationCard
      dataDsId={dataDsId}
      title={
        <div className="flex items-center">
          <TooltipBubble
            placement="top-start"
            title={folder?.name}
            disabled={folder?.name.length < 16}
          >
            <div className="flex max-w-[155px] mr-2 truncate">
              <TextButton
                label={folder?.name}
                color="text-ds-natural-600"
                ellipsis
              />
            </div>
          </TooltipBubble>
          <div className="pb-0.5">
            <TextButton
              label={`(${folder?.totalItems ?? 0})`}
              color="text-ds-natural-300"
            />
          </div>
        </div>
      }
      disabled={disabled}
      actionOnHover
      onClick={() => onTileClick(folder)}
      containerClass="w-full"
      small
      action={
        !folder.readOnly && (
          <FolderActions
            folderId={folder.id}
            folderName={folder.name}
            onOpenChange={setIsMenuOpen}
            open={isMenuOpen}
            side="right"
            sideOffset={19}
            isArchived={isArchived}
          />
        )
      }
      image={
        folder?.readOnly ? (
          <SharedFolderIcon
            size={20}
            color={ColorHex.natural500}
          />
        ) : (
          <FolderIcon
            size={20}
            color={ColorHex.natural500}
          />
        )
      }
    />
  );
};
